export const propertySegments = [
  {
    id: 1,
    title: "Premium Apartments",
    icon: "building-2",
    description: "1BHK, 2BHK, and Studio apartments in gated colonies",
    features: [
      "Ready-to-move & under-construction",
      "Inside premium gated colonies",
      "MVDA & RERA approved",
      "Bank loan available"
    ],
    types: ["1BHK", "2BHK", "Studio"]
  },
  {
    id: 2,
    title: "Independent Houses & Villas",
    icon: "home",
    description: "Premium villas and independent houses for peaceful living",
    features: [
      "Near Yamuna Ghat & Parikrama Marg",
      "Low-density developments",
      "Suitable for retirement",
      "Rental income potential"
    ],
    types: ["Independent House", "Premium Villa", "Duplex"]
  },
  {
    id: 3,
    title: "Residential Plots",
    icon: "map",
    description: "MVDA approved plots for custom home construction",
    features: [
      "Clear title & registry-ready",
      "Gated plotting projects",
      "Approved land use",
      "Custom home construction"
    ],
    types: ["100 sq.yd", "200 sq.yd", "300 sq.yd+"]
  }
];

export const featuredProperties = [
  {
    id: 1,
    title: "Luxury 2BHK Apartment",
    type: "Apartment",
    location: "Near Premanand Ji Ashram",
    price: "₹45 Lakhs",
    size: "1200 sq.ft",
    status: "Ready to Move",
    bedrooms: 2,
    bathrooms: 2,
    featured: true
  },
  {
    id: 2,
    title: "Independent Villa",
    type: "Villa",
    location: "Yamuna Ghat Road",
    price: "₹1.2 Crores",
    size: "2500 sq.ft",
    status: "Under Construction",
    bedrooms: 3,
    bathrooms: 3,
    featured: true
  },
  {
    id: 3,
    title: "Studio Apartment",
    type: "Studio",
    location: "Keli Kunj Area",
    price: "₹28 Lakhs",
    size: "550 sq.ft",
    status: "Ready to Move",
    bedrooms: 1,
    bathrooms: 1,
    featured: true
  },
  {
    id: 4,
    title: "Residential Plot",
    type: "Plot",
    location: "Chhatikara Road",
    price: "₹35 Lakhs",
    size: "200 sq.yd",
    status: "MVDA Approved",
    featured: false
  }
];

export const keyLocations = [
  "Vrindavan",
  "Mathura",
  "Chhatikara Road",
  "Sunrakh",
  "Goverdhan Road",
  "Yamuna Expressway Belt",
  "Premanand Ji Maharaj Ashram",
  "Keli Kunj Vrindavan",
  "Yamuna Ghat",
  "Parikrama Marg"
];

export const whyChooseUs = [
  {
    icon: "shield-check",
    title: "MVDA & RERA Approved",
    description: "Only legally compliant and verified properties"
  },
  {
    icon: "map-pin",
    title: "Local Expertise",
    description: "Deep knowledge of Vrindavan real estate market"
  },
  {
    icon: "building",
    title: "Premium Colonies",
    description: "Exclusive gated communities with modern amenities"
  },
  {
    icon: "handshake",
    title: "Honest Consultation",
    description: "No-pressure, transparent guidance for your investment"
  },
  {
    icon: "trending-up",
    title: "Investment Focused",
    description: "Long-term value and growth-oriented properties"
  },
  {
    icon: "headphones",
    title: "Post-Sale Support",
    description: "Continuous assistance even after purchase"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Sharma",
    location: "Delhi",
    rating: 5,
    text: "Vrindavan Calling helped us find the perfect spiritual home near Premanand Ji Ashram. Professional and trustworthy service!"
  },
  {
    id: 2,
    name: "Priya Patel",
    location: "Mumbai",
    rating: 5,
    text: "Excellent guidance on MVDA approved plots. The team ensured all legal documentation was perfect."
  },
  {
    id: 3,
    name: "Amit Kumar",
    location: "Bangalore",
    rating: 5,
    text: "Best real estate consultant in Vrindavan. They understand both investment value and spiritual significance."
  }
];